<div class="faq-page w-full min-w-0">
  <!-- Header: title + search -->
  <div
    class="flex flex-col gap-3 md:flex-row md:items-center md:justify-between md:gap-4 mb-4 md:mb-6"
  >
    <h1
      class="text-[#0A0A5F] text-xl sm:text-2xl font-bold leading-tight shrink-0"
    >
      Frequently Asked Question
    </h1>

    <div
      class="w-full md:max-w-sm lg:max-w-md h-10 p-2 rounded-md border border-gray-300 flex items-center gap-2 bg-white"
    >
      <input
        type="text"
        class="flex-1 min-w-0 text-sm font-medium text-gray-500 bg-transparent border-none outline-none focus:outline-none focus:ring-0 p-0 md:hidden"
        placeholder="Search by part/scrap name"
        [(ngModel)]="searchTerm"
        (keydown.enter)="searchFAQ()"
        (input)="onSearchInput($event)"
        (keydown)="onSearchKeyPress($event)"
      />
      <input
        type="text"
        class="hidden md:block flex-1 min-w-0 text-sm font-medium text-gray-500 bg-transparent border-none outline-none focus:outline-none focus:ring-0 p-0"
        placeholder="Type a question, topic or issue"
        [(ngModel)]="searchTerm"
        (keydown.enter)="searchFAQ()"
        (input)="onSearchInput($event)"
        (keydown)="onSearchKeyPress($event)"
      />
      <button
        type="button"
        class="shrink-0 text-gray-500 hover:text-[#0A0A5F]"
        (click)="searchFAQ()"
        aria-label="Search FAQs"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="md:w-6 md:h-6"
        >
          <path
            d="M13.8807 13.8807C16.4842 11.2772 16.4842 7.05612 13.8807 4.45262C11.2772 1.84913 7.05612 1.84913 4.45262 4.45262C1.84913 7.05612 1.84913 11.2772 4.45262 13.8807C7.05612 16.4842 11.2772 16.4842 13.8807 13.8807ZM13.8807 13.8807L17.5 17.5"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
  </div>

  <!-- Category tabs -->
  <div class="w-full overflow-x-auto border-b border-gray-200 mb-4 md:mb-6 scrollbar-hide">
    <div class="flex gap-1 sm:gap-2 min-w-fit">
      <button
        type="button"
        *ngFor="let tab of getNavigationTabs()"
        (click)="setActiveTab(tab)"
        class="px-3 sm:px-4 md:px-6 py-2 cursor-pointer whitespace-nowrap text-sm md:text-base font-bold transition-colors border-b-2 -mb-px"
        [class.text-[#307FE1]]="activeTab === tab"
        [class.border-[#307FE1]]="activeTab === tab"
        [class.text-gray-500]="activeTab !== tab"
        [class.border-transparent]="activeTab !== tab"
      >
        {{ tab }}
      </button>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="isLoading" class="flex justify-center items-center py-10">
    <p class="text-black text-base font-medium">Loading FAQs...</p>
  </div>

  <!-- FAQ sections -->
  <div *ngIf="!isLoading" class="flex flex-col gap-6 md:gap-8 lg:gap-10">
    <section
      *ngFor="let tab of getVisibleTabs()"
      class="faq-section flex flex-col gap-3 md:flex-row md:gap-6 lg:gap-8"
    >
      <!-- Category intro: stacked on mobile, left column on tablet+ -->
      <div class="w-full md:w-[30%] lg:w-[28%] shrink-0 flex flex-col gap-1">
        <h2 class="text-base md:text-lg font-bold text-black">{{ tab }}</h2>
        <p class="text-xs md:text-sm text-gray-600 leading-relaxed">
          {{ faqData[tab].description }}
        </p>
      </div>

      <!-- Questions accordion -->
      <div class="flex-1 min-w-0 flex flex-col">
        <div
          *ngFor="let question of faqData[tab]?.questions; let i = index"
          class="py-3 border-b border-gray-200 cursor-pointer"
          (click)="toggleQuestion(activeTab, tab, i)"
        >
          <div class="flex justify-between items-start gap-3">
            <h3
              class="text-sm md:text-base font-bold text-black leading-snug flex-1 min-w-0"
            >
              {{ question.question }}
            </h3>
            <svg
              width="20"
              height="20"
              class="shrink-0 mt-0.5 transition-transform duration-200"
              [class.rotate-180]="isQuestionExpanded(activeTab, tab, i)"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 7.5L10 12.5L15 7.5"
              />
            </svg>
          </div>
          <div
            *ngIf="isQuestionExpanded(activeTab, tab, i)"
            class="mt-3 text-sm text-gray-700 leading-relaxed"
          >
            {{ question.answer }}
          </div>
        </div>
      </div>
    </section>

    <div
      class="flex justify-center items-center py-16 text-gray-500 font-medium"
      *ngIf="noDataFound"
    >
      No Data Found
    </div>
  </div>
</div>
